<template>
    <Modal
        @submit="submit"
        :actions="modalActions"
        @close="close"
        title="JOIN_SCHOOL"
    >
        <EditSection
            :errors="errors"
            :sections="joinSections"
            ref="mainSections"
        ></EditSection>
    </Modal>
</template>
<script>
export default {
    data() {
        return {
            errors: new this.$Errors(),
            loading: false,
            joinSections: {
                token: {
                    title: this.$t('INVITE_CODE'),
                    placeholder: this.$t('ENTER_CODE'),
                    value: '',
                    type: 'text-input',
                    key: 'token'
                }
            }
        }
    },
    computed: {
        modalActions() {
            return [
                {
                    action: 'submit',
                    display: 'SAVE',
                    loading: this.loading
                }
            ]
        }
    },
    methods: {
        submit() {
            if (this.loading) {
                return
            }
            const data = {
                token: this.joinSections.token.value,
                mail: this.$store.state.user.claims.mail
            }
            this.$api
                .post(`v1/qr`, data)
                .then(() => {
                    this.$emit('updated')
                    this.$emit('close')
                })
                .catch(error => {
                    this.loading = false
                    this.$Network.handleError(error, this.errors)
                })
        },
        close() {
            this.$emit('close')
        }
    }
}
</script>
